import { Routes, Route } from "react-router-dom";
import TajweedRuleList from "./list";
import TajweedRuleForm from "./form";
import AnnotationList from "./list";
import AnnotationForm from "./form";

function AnnotationPage() {
	return (
		<Routes>
			<Route path="/" element={<AnnotationList />} />
			<Route path="/add" element={<AnnotationForm />} />
			<Route path="/:c/:v" element={<AnnotationForm />} />
		</Routes>
	);
}

export default AnnotationPage;
